import "./App.css";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { arrow_line, bg_circle, coin, coin2, prdt, tradeX } from "./images";
import ContestDetails from "./ContestDetails";
import HowToParticipate from "./HowToParticipate";
import Prize from "./Prize";
import LeaderBoard from "./components/LeaderBoard";

function App() {
  const [isSelected, setIsSelected] = useState("Home");
  const navOptions = ["Home", "PRDT", "TradeX", "LeaderBoard"];

  function navBarClick(value) {
    if (isSelected !== value) {
      setIsSelected(value);
    }
  }

  return (
    <div style={{ backgroundColor: "#F6F6F6" }}>
      <img src={bg_circle()} width={"100%"} className="bg-img-circle"></img>
      {isSelected !== "LeaderBoard" && (
        <>
          <img src={coin()} width={120} className="bg-coin"></img>
          <img src={coin2()} width={80} className="bg-coin-2"></img>
        </>
      )}
      {isMobile &&
      isSelected !== "Home" &&
      isSelected !== "LeaderBoard" ? null : (
        <div className={`disclaimer-box`}>
          <div>
            <p className={"disclaimer-text"}>
              Top 50 traders will share upto 1000 USDT rewards pool (T&C apply)
            </p>
          </div>
        </div>
      )}
      <div className={`header-box`}>
        <div className={"nav-bar-blk"}>
          {navOptions?.map((data, i) => {
            return (
              <div
                onClick={() => {
                  navBarClick(data);
                }}
                className={"nav-bar-options"}
              >
                <p
                  className={
                    isSelected === data
                      ? "nav-bar-selected-text"
                      : "nav-bar-text"
                  }
                >
                  {data}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      {isSelected === "Home" && (
        <>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className={"title-bar"}>
              <img src={tradeX()} height={45}></img>

              <p style={{ color: "#000000" }} className={"nav-bar-text"}>
                +
              </p>
              <img src={prdt()} height={40}></img>
            </div>
          </div>
          <div>
            <p className={"title-text"}>
              Welcome to the exciting joint trading contest <br /> hosted by
              <span className={"gradient-text"}> TradeX and PRDT Finance!</span>
            </p>
            <p className={"sub-title-text"}>
              We're thrilled to bring together traders from both platforms
              <br /> for a week-long trading extravaganza.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: 20,
                marginTop: -10,
              }}
            >
              <p
                onClick={() => {
                  navBarClick("TradeX");
                }}
                className={"button-plain button-gradient"}
              >
                TradeX
              </p>
              <p
                onClick={() => {
                  navBarClick("PRDT");
                }}
                className={"button-gradient"}
              >
                PRDT
              </p>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={arrow_line()}
                height={70}
                style={{ margin: 10, zIndex: 10 }}
              ></img>
            </div>
          </div>

          <ContestDetails />
          <HowToParticipate />
          <Prize />
        </>
      )}
      {(isSelected === "PRDT" || isSelected === "TradeX") && (
        <>
          <div
            style={{
              height: "100%",
              zIndex: 90,
              backgroundColor: "#F6F6F6",
              display: "flex",
              marginTop: isMobile ? 0 : 30,
              // paddingBottom: 100,
              justifyContent: "center",
            }}
          >
            <iframe
              src={
                isSelected === "PRDT"
                  ? "https://prdt.finance/tradex/poly"
                  : "https://web.tradexapp.co/Home"
              }
              className="tradex-iframe"
            />
          </div>
        </>
      )}
      {isSelected === "LeaderBoard" && (
        <div
          style={{
            height: "100%",
            zIndex: 90,
            backgroundColor: "#F6F6F6",
            display: "flex",

            // marginTop: isMobile ? 0 : 30,
            // paddingBottom: 100,
            justifyContent: "center",
          }}
        >
          <LeaderBoard />
        </div>
      )}
    </div>
  );
}

export default App;
